import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'servicos/fornecedores',
		component: Base,
		children: [
			{
				path: '',
				name: 'FornecedoresList',
				component: List,
				meta: {
					path: '/servicos/fornecedores',
					pai: 'Serviços',
					title: 'Admin - Fornecedores',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Fornecedores',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'FornecedoresNovo',
				component: Form,
				meta: {
					path: '/servicos/fornecedores',
					pai: 'Serviços',
					title: 'Admin - Fornecedores - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Fornecedores',
						class: '',
						active: false,
						url: '/servicos/fornecedores'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'FornecedoresEditar',
				component: Form,
				meta: {
					path: '/servicos/fornecedores',
					pai: 'Serviços',
					title: 'Admin - Fornecedores - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Fornecedores',
						class: '',
						active: false,
						url: '/servicos/fornecedores'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]